import React, {useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import awsLogo from '../../resources/media/aws.svg';
import azureLogo from '../../resources/media/azureCenter.svg';
import { NavigableDropdown as DropDown } from '../../components/navigableDropdown';

function CloudRegionPickerView({cloudId, selectedCloudType, selectedItem, availableItems, setSelectedCloudType, setSelected, showRadioButton}) {
    const [selectedRegion, setSelectedRegion] = useState(selectedItem);

    const getRadioIcon = (cloudType) => {
        const imageSettings = {
            'aws': {
                logo: awsLogo,
                imgWidth: '92px',
            },
            'azure': {
                logo: azureLogo,
                imgWidth: '120px',
            },
        };

        if (_.isEmpty(imageSettings[`${cloudType}`])) {
            imageSettings[`${cloudType}`] = {};
        }


        return (
            <>
                <span
                    id={`picker-img-${cloudType}`}
                    className={classnames({'tw-pb-2px': cloudType !== 'aws' && cloudType !== 'azure'}, {'tw-pt-2px': cloudType === 'aws'}, {'tw-ml-18px': cloudType !== 'aws' && cloudType !== 'azure'})}
                    onClick={_.partial(onSelectCloudType, cloudType)}>
                    {
                        !_.isEmpty(imageSettings[`${cloudType}`].logo) && <img id={`img-${cloudType}`} src={imageSettings[`${cloudType}`].logo} width={imageSettings[`${cloudType}`].imgWidth} alt={_.toUpper(cloudType)}/>
                    }
                    {
                        _.isEmpty(imageSettings[`${cloudType}`].logo) && <label id={`label-${cloudType}`} className="tw-mt-5px">{_.toUpper(cloudType)}</label>
                    }
                </span>
            </>
        );
    }

    const getRegions = (availableItems) => {
        return _.transform(availableItems, (result, item) => {
            const region = {
                key: item.description,
                label: item.name,
                item: item
            };
            result.push(region);
        }, []);
    }

    const onSelectCloudType = (cloudType) => {
        setSelectedCloudType(cloudType);
        setSelected(selectedRegion);
    }


    const onSelectedRegion = (selectedKey) => {
        const item = _.filter(availableItems, {description: selectedKey});
        setSelectedRegion(_.isEmpty(item) ? {} : item[0]);
        setSelected(_.isEmpty(item) ? {} : item[0]);
    }

    const renderName = (selectedRegion) => {
        if (!_.isEmpty(selectedRegion)) {
            return selectedRegion.name;
        }
        return null;
    }

    return (
        <div className="tw-pt-sm" id={`picker-${cloudId}`}>
            <div id={`ci-region-title-view-${cloudId}`} className="tw-h-auto" data-testid={`ci-region-title-view-${cloudId}`}>
                <div id={`radios-container-${cloudId}`} className="tw-grid tw-grid-2-cols-15-85-row-50" >
                    {
                        <span id={`span-picker-${cloudId}`} className="tw-flex tw-mr-med tw-mb-20px">
                            {
                                showRadioButton && (<input
                                    key={`item-${cloudId}`}
                                    className="tw-mr-xs tw-mt-8px"
                                    id={`item-${cloudId}`}
                                    type="radio"
                                    name={cloudId}
                                    value={cloudId}
                                    checked={_.isEqual(cloudId, selectedCloudType)}
                                    onClick={_.partial(onSelectCloudType, cloudId)}
                                    onChange={_.partial(onSelectCloudType, cloudId)}
                                />)
                            }
                            {
                                getRadioIcon(cloudId)
                            }
                        </span>
                    }
                    <div className="col-lg-4 col-sm-4 col-md-4 col-xl-4">
                        <DropDown
                            id={`cloud-region-${cloudId}`}
                            className="tw-bg-white tw-text-med tw-font-normal"
                            labelClassName='tw-text-med tw-font-normal tw-py-5px'
                            caretOpenClassName='tw-text-white-override dark:tw-text-white'
                            caretClassName={classnames('dark:tw-text-gray-500', {'tw-text-white-override': _.isEqual(cloudId, selectedCloudType)}, {'tw-text-gray-disabled': !_.isEqual(cloudId, selectedCloudType)})}
                            itemClassName='tw-text-med'
                            buttonLabel={renderName(selectedRegion)}
                            listOptions={getRegions(availableItems)}
                            disabled={!_.isEqual(cloudId, selectedCloudType)}
                            placeHolderLabel="Select a Region"
                            onSelect={onSelectedRegion}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

CloudRegionPickerView.displayName = 'CloudRegionPickerView';
CloudRegionPickerView.propTypes = {
    cloudId: PropTypes.string,
    selectedItem: PropTypes.object,
    selectedCloudType: PropTypes.string,
    availableItems: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    setSelectedCloudType: PropTypes.func.isRequired,
    cloudName: PropTypes.string,
    showRadioButton: PropTypes.bool.isRequired,
};

export default CloudRegionPickerView;
